module.exports = __webpack_public_path__ + "img/sq-8.a093732f.jpg";